import { GridApi } from 'ag-grid-community'
import { useCallback } from 'react'
import { useDialogState } from '../../../components/dialogs/useDialogState'
import { exportExcel } from '../../../containers/BulkSheet/excel'

export const useExcel = (gridApi: GridApi | undefined) => {
  const [dialogOpen, openDialog, closeDialog] = useDialogState()

  const onExportExcel = useCallback(
    (selectedColIds: string[]) => {
      if (!gridApi) return
      exportExcel({
        fileNamePrefix: 'TaskActualWorkApprovalStatus',
        gridApi,
        exportColIds: selectedColIds,
      })
      closeDialog()
    },
    [gridApi, closeDialog]
  )

  return {
    dialogOpen,
    openDialog,
    closeDialog,
    onExportExcel,
  }
}
